import { ReactElement } from 'react';

type IProps = {
  children: ReactElement[] | ReactElement;
  otherClasses?: string;
};

const ClassicCard: React.FC<IProps> = ({ otherClasses, children }) => {
  return <div className={`bg-dark-200 rounded-20 ${otherClasses ? otherClasses : ''}`}>{children}</div>;
};
export default ClassicCard;
